import { apiAuth } from "../../http";

export const deleteStory = async (id: string): Promise<[]> => {
  const response = apiAuth()
    .delete(`/stories/${id}`)
    .then(({ data }) => data);
  return response;
};
